import { create } from 'zustand';

type AnimationStoreProps = {
  startBannerAnimation: boolean;
  changeStartBannerAnimation: (start: boolean) => void;
};

export const useAnimationStore = create<AnimationStoreProps>((set) => ({
  startBannerAnimation: false,
  changeStartBannerAnimation: (start) => {
    set({
      startBannerAnimation: start
    });
  }
}));
